// extracted by mini-css-extract-plugin
export default {"AccountViewContent":"accountView_AccountViewContent__jiwrO","DeleteModalContent":"accountView_DeleteModalContent__EGwpo"};